export default __webpack_public_path__ + "static/2-sexy-2026-icon-606d1283e6f5067cc8cde7cdb467be33.png";